import { z } from 'zod';

import { LosId, PaymentId } from '../../BrandedIds';
import { PaymentMethod, PaymentStatus } from '../../loan/Payments';
import { zodTemporalInstant, zodTemporalPlainDate } from '../../Temporal';

/**
 * This is pretty bare and needs more fields from the whole union type.
 */
export const ExportablePayment = z
  .object({
    id: PaymentId,
    loanId: LosId,
    total: z.number(),
    method: PaymentMethod,
    paymentDate: zodTemporalPlainDate,
    processedDate: zodTemporalPlainDate.optional(),
    status: PaymentStatus,
    createdAt: zodTemporalInstant,
  })
  .meta({ title: 'Payment' });
export type ExportablePayment = z.infer<typeof ExportablePayment>;
